module.exports = __webpack_public_path__ + "img/About_Desktop_03.eaadf43c.jpg";